// Utilities to scale + format ingredient quantities

const UNICODE_FRACTIONS = {
  0.125: "⅛",
  0.25: "¼",
  0.333: "⅓",
  0.334: "⅓",
  0.375: "⅜",
  0.5: "½",
  0.625: "⅝",
  0.667: "⅔",
  0.666: "⅔",
  0.75: "¾",
  0.875: "⅞",
};

// Round to nearest common cooking fraction (1/8 step)
function roundToKitchen(n) {
  if (n >= 10) return Math.round(n);
  if (n >= 2) return Math.round(n * 4) / 4; // quarter
  return Math.round(n * 8) / 8; // eighth
}

export function formatQty(n) {
  if (n == null || isNaN(n)) return "";
  const rounded = roundToKitchen(n);
  if (rounded === 0) return "a pinch";

  const whole = Math.floor(rounded);
  const frac = +(rounded - whole).toFixed(3);

  if (frac === 0) return `${whole}`;

  // Look for unicode fraction match (with small tolerance)
  const match = Object.keys(UNICODE_FRACTIONS).find(
    (k) => Math.abs(parseFloat(k) - frac) < 0.02
  );
  const fracStr = match ? UNICODE_FRACTIONS[match] : frac.toFixed(2).replace(/\.?0+$/, "");

  return whole === 0 ? fracStr : `${whole} ${fracStr}`;
}

export function scaleIngredient(ing, servings, baseServings) {
  if (!ing.scalable) return { ...ing, displayQty: formatQty(ing.qty) };
  const factor = servings / baseServings;
  const scaled = ing.qty * factor;
  return { ...ing, displayQty: formatQty(scaled) };
}
